import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges, Type, ViewContainerRef } from '@angular/core';
import { Grid, GridBanner, KwikstoreSection } from '../models/sections-model';

@Directive({
  selector: '[kwRenderSection]'
})
export class RenderSectionDirective implements OnChanges,AfterViewInit{
  @Input() section:KwikstoreSection<any>
  @Input() rendererComponent:any;
  @Input() title:string;
  @Input() marginBottom:number
  
  heading:string;

  constructor(public viewContainerRef: ViewContainerRef,
    private renderer:Renderer2,
    private el:ElementRef<HTMLElement>) { }
  

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["section"]){
      //console.log(this.section);
      //console.log(this.rendererComponent);
      if(this.section != undefined){
        this.heading = this.section.heading;
      //this.viewContainerRef.element
      //console.log(this.viewContainerRef.element);
      //let t:Type<any> = typeof this.section;
      if(this.section instanceof Grid){
        console.log("It's a grid");
        console.log(this.viewContainerRef.element.nativeElement);
      }
      }
      
    }
    
  }

  ngAfterViewInit(): void {
    //console.log(this.el.nativeElement);
    if(this.marginBottom != null && this.marginBottom != undefined){
      let hostEl = <HTMLElement>this.el.nativeElement.nextSibling;
      console.log(hostEl);
      //this.renderer.setStyle(<HTMLElement>this.el.nativeElement.nextSibling,"margin-bottom",this.marginBottom+"px")
      //console.log(this.marginBottom);
      //this.el.nativeElement.style.setProperty("margin-bottom",this.marginBottom+"px")
    }
  }


}
